module.exports = __webpack_public_path__ + "static/media/icon-calls.3c8fabf3.svg";